import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  useDispatch,
  Form,
  connect,
  useRouter,
} from "../../../atoms/DependencyHelper";
import PageHeading from "../../../atoms/pageHeading/PageHeading";
import DeliveryDetailsForm from "../../../atoms/newLineForms/creditCheckForms/deliveryDetailsForm/DeliveryDetailsForm";
import ContentSearchBox from "../../../atoms/contentSearchBox/ContentSearchBox";
import DeliveryDetailsInfo from "../../../atoms/newLineForms/creditCheckDetails/deliveryDetailsInfo/DeliveryDetailsInfo";
import ReceiveType from "../../../molecules/receiveType/ReceiveType";
import DropDown from "../../../atoms/newLineForms/dropDown/DropDown";
import AddressTile from "../../../atoms/addressTile/AddressTile";
import DeliveryTitle from "../../../atoms/deliveryTitle/DeliveryTitle";
import CheckoutFormsModal from "../../../molecules/modals/checkoutFormsModal/CheckoutFormsModal";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import {
  imagePrefix,
  numRegEx,
  streetNameRegEx,
  showSpinner,
  hideSpinner,
  getCookieValue,
  getValueLabel,
  matchWordInString,
  urlPrefix,
  generateFormURL,
} from "../../../../utils/helperServices";
import {
  UNIT,
  BUSINESS,
  STREET_NO,
  ROUTE,
  SUBURB,
  PROVINCE,
  POST_STREET,
  TOWN,
  CITY,
} from "../../../../config/constants";
import formStyles from "../CheckoutCreditCheck.module.scss";
import styles from "./DeliveryDetails.module.scss";
import errorMessages from "../../../../config/errorMessages";
import ajaxService from "../../../../utils/ajaxServices";
import Image from "../../../atoms/image/image";
import labels from "../../../../config/labels";
import * as Analytics from "../../../../services/analyticsUtag";

import {
  getAllCustomerAddressListsService,
  setNewBillingAddressService,
  setExistingBillAddressService,
  setShippingMethodsOnCartService,
} from "../../../../services/checkoutService";

import {
  SET_SHIPPING,
  SET_BILLING,
  SET_SHIPPING_METHOD,
  SET_CREDIT_CHECK_DELIVERY_DATA,
} from "../../../../Redux/actionTypes/index";

import { setReLogin } from "../../../../Redux/actions/navAction";
import { journeyType } from "../../../../context/checkout-journey-context";

const receiveTypesOptions = [
  {
    id: "courier",
    label: "Deliver via courier",
    hide: false,
  },
  {
    id: "store",
    label: "Collect in store",
    hide: true,
  },
];

const types1 = [
  {
    id: "home",
    label: "My home address",
  },
  {
    id: "another",
    label: "Another delivery address",
  },
];

const types2 = [
  {
    id: "home",
    label: "My home address",
  },
  {
    id: "previous",
    label: "One of my previous delivery addresses",
  },
  {
    id: "another",
    label: "Another delivery address",
  },
];

const DeliveryDetails = ({
  userLoggedIn,
  profileData,
  customerStatus,
  personalDetailsData,
  homeDetailsData,
  contactDetailsData,
  deliveryDetailsData,
  addressTypes,
  statesTypes,
  shippingAddress,
  countryCode,
  countryName,
  setShowSnackBar,
  setPageErr,
  navigate,
  onFormSubmit,
  profileLoading,
  setReLogin,
  carrierCode,
  methodCode,
  currentJourneyType,
  doCreditCheckDisable,
}) => {
  const cartId = getCookieValue("cart_id");
  const [analytics, setAnalytics] = useState(false);
  const [displayEditMode, setDisplayEditMode] = useState(
    deliveryDetailsData ? false : true
  );
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [finalAddress, setFinalAddress] = useState([]);
  const [selectedReceiveType, setSelectedReceiveType] = useState("courier");
  const [selectedDeliveryType, setSelectedDeliveryType] = useState("home");
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(false);

  const [modalType, setModalType] = useState("delivery");
  const [modalVariant, setModalVariant] = useState("edit");
  const [modalValues, setModalValues] = useState({});
  const [modalShow, setModalShow] = useState(false);

  const [submitAttempt, setSubmitAttempt] = useState(0);

  const [deliveryTypeOptions, setDeliveryTypeOptions] = useState(types1);
  const addressTypesOptions = addressTypes ? addressTypes : [];
  const stateTypesOptions = statesTypes ? statesTypes : [];

  const RESIDENTIAL_ADDRESS_TYPE =
    addressTypesOptions && addressTypesOptions.length > 0
      ? addressTypesOptions[0].id
      : "";
  const BUSINESS_ADDRESS_TYPE =
    addressTypesOptions && addressTypesOptions.length > 0
      ? addressTypesOptions[1].id
      : "";

  const [deliveryAddresslists, setDeliveryAddresslists] = useState([]);
  const [totalDeliveryAddress, setTotalDeliveryAddress] = useState(0);

  const titleContents =
    labels.creditCheckout.deliveryDetails.lbl_store_contents;

  const cloneOfErrorMessages = JSON.parse(
    JSON.stringify(errorMessages.creditCheckout.errors.delivery)
  );

  const router = useRouter();
  const dispatch = useDispatch();

  const createStreetString = (arr) => {
    let res = arr;
    if (Array.isArray(arr) && arr.length > 0) {
      res = arr.join(", ");
    }
    return res;
  };

  useEffect(() => {
    if (displayEditMode && !profileLoading) {
      closeSnackBar();
      fetchData();
      setFormDetailInformation();
    }
  }, [displayEditMode, profileLoading]);

  useEffect(() => {
    addressSearchResultMap();
  }, [finalAddress]);

  useEffect(() => {
    if (addressTypesOptions.length > 0) {
      fieldValues.deliveryDetails.addressType = RESIDENTIAL_ADDRESS_TYPE;

      if (addressTypesOptions[2]) {
        //Remove postal adddress type
        addressTypesOptions.splice(2, 1);
      }

      setState({
        ...state,
        fieldValues,
      });
    }
  }, [addressTypesOptions]);

  useEffect(() => {
    if (stateTypesOptions.length > 0) {
      fieldValues.deliveryDetails.province = stateTypesOptions[0].id;

      setState({
        ...state,
        fieldValues,
      });
    }
  }, [stateTypesOptions]);

  useEffect(() => {
    if (selectedReceiveType == "courier") {
      if (selectedDeliveryType == "home" && homeDetailsData) {
        setSubmitDisabled(false);
      } else if (
        selectedDeliveryType == "previous" &&
        totalDeliveryAddress !== 0 &&
        selectedDeliveryAddress
      ) {
        setSubmitDisabled(false);
      } else if (
        selectedDeliveryType == "another" &&
        !checkFormError("deliveryDetails")
      ) {
        setSubmitDisabled(false);
      } else {
        setSubmitDisabled(true);
      }
    } else if (selectedReceiveType == "store") {
      setSubmitDisabled(true);
    }
  }, [
    selectedDeliveryType,
    selectedReceiveType,
    selectedDeliveryAddress,
    homeDetailsData,
  ]);

  useEffect(() => {
    if (totalDeliveryAddress > 0) {
      setDeliveryTypeOptions(types2);
    }
  }, [totalDeliveryAddress]);

  const fetchData = async () => {
    try {
      showSpinner();
      let results = await getAllCustomerAddressListsService();

      if (!results.fail) {
        await filterAddressLists(results.addressList);
        hideSpinner();
      } else {
        hideSpinner();
        if (results && results.errors) {
          technicalFailure(results.errors?.[0]?.message);
        } else {
          technicalFailure();
        }
      }
    } catch {
      hideSpinner();
      technicalFailure();
    }
  };

  const getProvinceValue = (name) => {
    var finalID = stateTypesOptions.filter((item) => item.code == name);
    if (finalID && finalID[0] && finalID[0].id) {
      return finalID[0].id;
    }
  };

  const filterAddressLists = (addressLists) => {
    if (addressLists && addressLists.length > 0) {
      let deliveryLists = [];

      addressLists.map((address) => {
        if (address.is_shipping_address) {
          deliveryLists.push(address);

          if (
            shippingAddress &&
            shippingAddress.customer_address_id &&
            shippingAddress.customer_address_id == address.id
          ) {
            setSelectedDeliveryAddress(shippingAddress.customer_address_id);
          } else if (
            address.default_shipping &&
            address.default_shipping == true &&
            !selectedDeliveryAddress
          ) {
            setSelectedDeliveryAddress(address.id);
          }
        }
      });

      setTotalDeliveryAddress(deliveryLists.length);
      setDeliveryAddresslists(deliveryLists);
    } else {
      setTotalDeliveryAddress(0);
      setDeliveryAddresslists([]);
    }
  };

  const displayHomeAddress = () => {
    let finalAdd = "";
    if (homeDetailsData) {
      let neUnit =
        homeDetailsData?.unitNo !== "" && homeDetailsData?.complexName !== ""
          ? homeDetailsData.unitNo + " " + homeDetailsData.complexName + ", "
          : homeDetailsData?.unitNo !== ""
          ? homeDetailsData.unitNo + ", "
          : homeDetailsData?.complexName !== ""
          ? homeDetailsData.complexName + ", "
          : "";
      let neStreet =
        homeDetailsData?.streetNo !== "" && homeDetailsData?.streetName !== ""
          ? homeDetailsData.streetNo + " " + homeDetailsData.streetName + ", "
          : homeDetailsData?.streetNo !== ""
          ? homeDetailsData.streetNo + ", "
          : homeDetailsData?.streetName !== ""
          ? homeDetailsData.streetName + ", "
          : "";
      let neSuburb =
        homeDetailsData?.suburb !== "" ? homeDetailsData.suburb + ", " : "";
      let neTown =
        homeDetailsData?.town !== "" ? homeDetailsData.town + ", " : "";
      let neProvince =
        homeDetailsData?.province !== ""
          ? getValueLabel(homeDetailsData.province, stateTypesOptions) + ", "
          : "";
      let nePostal =
        homeDetailsData?.postalCode !== "" ? homeDetailsData.postalCode : "";

      finalAdd = neUnit + neStreet + neSuburb + neTown + neProvince + nePostal;
    }

    return finalAdd;
  };

  const seperateStreetString = (str) => {
    if (str && str !== "") {
      return str.split(", ");
    } else {
      return null;
    }
  };

  const getRegionValue = (id) => {
    return id && id !== "" ? statesTypes.find((item) => item.id == id) : null;
  };

  function setFormDetailInformation() {
    if (deliveryDetailsData) {
      fieldValues.deliveryDetails.addressName =
        deliveryDetailsData.address.addressName;
      fieldValues.deliveryDetails.addressType =
        deliveryDetailsData.address.addressType;
      fieldValues.deliveryDetails.companyName =
        deliveryDetailsData.address.companyName;
      fieldValues.deliveryDetails.unitNo = deliveryDetailsData.address.unitNo;
      fieldValues.deliveryDetails.complexName =
        deliveryDetailsData.address.complexName;
      fieldValues.deliveryDetails.streetNo =
        deliveryDetailsData.address.streetNo;
      fieldValues.deliveryDetails.streetName =
        deliveryDetailsData.address.streetName;
      fieldValues.deliveryDetails.suburb = deliveryDetailsData.address.suburb;
      fieldValues.deliveryDetails.postalCode =
        deliveryDetailsData.address.postalCode;
      fieldValues.deliveryDetails.town = deliveryDetailsData.address.town;
      fieldValues.deliveryDetails.province =
        deliveryDetailsData.address.province;
      fieldValues.deliveryDetails.instructions =
        deliveryDetailsData.address.instructions;
      fieldValues.deliveryDetails.futureCheck =
        deliveryDetailsData.address.futureCheck;

      errorStatus.deliveryDetails = checkFormError("deliveryDetails");

      if (errorStatus.deliveryDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      if (deliveryDetailsData.receiveType !== selectedReceiveType) {
        setSelectedReceiveType(deliveryDetailsData.receiveType);
      }

      if (
        deliveryDetailsData.address.futureCheck &&
        deliveryDetailsData.deliveryType == "another" &&
        deliveryTypeOptions === types2
      ) {
        setSelectedDeliveryType("previous");
      } else if (deliveryDetailsData.deliveryType !== selectedDeliveryType) {
        setSelectedDeliveryType(deliveryDetailsData.deliveryType);
      }

      setState({
        ...state,
        fieldValues,
        errorStatus,
      });
    }
  }

  const [state, setState] = useState({
    validationsOn: {
      deliveryDetails: true,
    },
    errorStatus: {
      deliveryDetails: true,
    },
    validations: {
      deliveryDetails: {
        addressName: true,
        addressType: true,
        companyName: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
        futureCheck: false,
      },
    },
    fieldErrors: {
      deliveryDetails: {
        addressName: false,
        addressType: false,
        companyName: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        futureCheck: false,
      },
      fail: false,
    },
    fieldValues: {
      deliveryDetails: {
        addressName: "",
        addressType: "",
        companyName: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
        futureCheck: false,
      },
    },
    readOnlyValues: {
      deliveryDetails: {
        addressName: false,
        addressType: false,
        companyName: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
      },
    },
    fieldErrorsMessage: cloneOfErrorMessages,
  });

  const {
    errorStatus,
    validations,
    fieldErrors,
    fieldValues,
    readOnlyValues,
    fieldErrorsMessage,
  } = state;

  useEffect(() => {
    if (customerStatus) {
      Analytics.link({
        page_event: "view",
        page_name: `checkout: credit check: ${customerStatus}`,
        page_channel: "checkout",
        page_master_tab: "personal",
        delivery_type: "deliver",
        ...Analytics.getProfileData(userLoggedIn, profileData),
      });
    }
  }, [customerStatus]);

  function mapFormData(values) {
    let formData = {
      addressName: "",
      addressType: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      unitNo: "",
      complexName: "",
      streetNo: "",
      streetName: "",
      suburb: "",
      postalCode: "",
      town: "",
      province: "",
      instructions: "",
    };

    if (values) {
      formData.addressName = values.address_name ? values.address_name : "";
      formData.addressType = values.address_type_name
        ? values.address_type_name
        : addressTypesOptions && addressTypesOptions.length > 0
        ? addressTypesOptions[0].id
        : "";
      formData.companyName = values.company ? values.company : "";
      formData.addressLine1 =
        values.street && values.street[0] ? values.street[0] : "";
      formData.addressLine2 =
        values.street && values.street[1] ? values.street[1] : "";
      formData.unitNo = values.unit_number ? values.unit_number : "";
      formData.complexName = values.complex_name ? values.complex_name : "";
      formData.streetNo = values.street_number ? values.street_number : "";
      formData.streetName = values.street
        ? createStreetString(values.street)
        : "";
      formData.suburb = values.suburb ? values.suburb : "";
      formData.postalCode = values.postcode ? values.postcode : "";
      formData.town = values.city ? values.city : "";
      formData.province = values.region
        ? values.region.region_id
        : stateTypesOptions && stateTypesOptions.length > 0
        ? stateTypesOptions[0].id
        : "";
      formData.instructions = values.instructions ? values.instructions : "";
    }

    return formData;
  }

  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */
  const handleBlur = async (event, val, form) => {
    const { name } = event.target;
    event.persist();
    await fieldValidationCheck(name, val, form, event);

    if (name == "addressType") {
      // Check form validation because field validation updated
      multipleFieldsValidationCheck(
        ["companyName", "unitNo", "complexName", "streetNo", "streetName"],
        form,
        event
      );
    }

    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      errorStatus,
    });

    if (fieldErrors.fail) {
      setSubmitDisabled(true);
      let errMsg = fieldErrorsMessage[form][name];
      inlineAnalytics(errMsg);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * Form input field change event handler
   *
   * @usage call updateFieldValues function
   * @call onChange event
   */
  const handleChange = async (event, val, form) => {
    event.persist();

    if (!analytics) {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "start",
        page_form_name: `checkout: credit check: ${customerStatus}: delivery details`,
      });
      setAnalytics(true);
    }

    await updateFieldValues(event, val, form);
  };

  /**
   * update input field values
   *
   * @usage Set the state of form validations, fieldValues
   */
  const updateFieldValues = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;
    if (name == "addressType") {
      validations[form].companyName = false;
      validations[form].unitNo = false;
      validations[form].complexName = false;
      validations[form].streetNo = false;
      validations[form].streetName = true;

      if (value == BUSINESS_ADDRESS_TYPE) {
        validations[form].companyName = true;
        validations[form].unitNo = true;
        validations[form].complexName = true;
        validations[form].streetNo = true;

        if (
          fieldValues[form].companyName == "" ||
          fieldValues[form].unitNo == "" ||
          fieldValues[form].complexName == "" ||
          fieldValues[form].streetNo == "" ||
          fieldValues[form].streetName == ""
        ) {
          fieldErrors[form].fail = true;
        } else {
          fieldErrors[form].fail = false;
        }
      }

      if(value == RESIDENTIAL_ADDRESS_TYPE) {
        validations[form].unitNo = true;
        validations[form].complexName = true;
        validations[form].streetNo = true;

        if(
          fieldValues[form].unitNo == "" ||
          fieldValues[form].complexName == "" ||
          fieldValues[form].streetNo == "" ||
          fieldValues[form].streetName == ""
        ) {
          fieldErrors[form].fail = true;
        } else {
          fieldErrors[form].fail = false;
        }
      }
    }

    if (name == "futureCheck") {
      fieldValues[form][name] = event.target.checked;
    } else {
      fieldValues[form][name] = value;
    }

    if (name == "addressType") {
      //capture analytics user selects "address type"
      selectionAnalytics(
        "address type",
        getValueLabel(value, addressTypesOptions)
      );
    } else if (name == "province") {
      //capture analytics user selects "province"
      selectionAnalytics("province", getValueLabel(value, stateTypesOptions));
    }

    setState({
      ...state,
      validations,
      fieldValues,
    });
  };

  const multipleFieldsValidationCheck = async (fieldsArray, form, event) => {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = fieldsArray.length;

    if (state.validationsOn[form]) {
      for (let i = 0; i < entries; i++) {
        if (values[fieldsArray[i]] !== "" || errors[fieldsArray[i]]) {
          fieldValidationCheck(
            fieldsArray[i],
            values[fieldsArray[i]],
            form,
            event
          );
        }
      }
    }
  };

  /**
   * Check input field validation
   *
   * @usage Set the state of form fieldErrors, fieldErrorsMessage
   */
  const fieldValidationCheck = async (name, val, form, event) => {
    const value = val ? val : event.target.value;

    switch (name) {
      case "addressName":
        if (state.validationsOn[form] && state.validations[form].addressName) {
          fieldErrors[form].addressName = value.length == 0 ? true : false;
          fieldErrors[form].fail = fieldErrors[form].addressName;
        } else {
          fieldErrors[form].addressName = false;
        }
        break;

      case "addressType":
        if (state.validationsOn[form] && state.validations[form].addressType) {
          fieldErrors[form].addressType = value.length == 0 ? true : false;
          fieldErrors[form].fail = fieldErrors[form].addressType;
        } else {
          fieldErrors[form].addressType = false;
        }
        break;

      case "companyName":
        if (state.validationsOn[form] && state.validations[form].companyName) {
          fieldErrors[form].companyName = value.length == 0 ? true : false;
          fieldErrors[form].fail = fieldErrors.companyName;
        } else {
          fieldErrors[form].companyName = false;
        }
        break;

      case "unitNo":
        if (value.length > 0) {
          fieldErrors[form].unitNo = numRegEx.test(value) ? false : true;
          if (fieldErrors[form].unitNo) {
            if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
              fieldErrorsMessage[form].unitNo =
                errorMessages.creditCheckout.deliveryDetails.floorNo.onlyNumber;
            } else {
              fieldErrorsMessage[form].unitNo =
                errorMessages.creditCheckout.deliveryDetails.unitNo.onlyNumber;
            }
          }
        } else {
          if (state.validationsOn[form] && state.validations[form].unitNo) {
            fieldErrors[form].unitNo = true;
          } else {
            fieldErrors[form].unitNo = false;
          }

          if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
            fieldErrorsMessage[form].unitNo =
              errorMessages.creditCheckout.errors.delivery.deliveryDetails.floorNo;
          } else {
            fieldErrorsMessage[form].unitNo =
              errorMessages.creditCheckout.errors.delivery.deliveryDetails.unitNo;
          }
        }

        if(state.fieldValues[form].unitNo !== "") {
          state.validations.delivery.complexName = true;
        }
        fieldErrors[form].fail = fieldErrors[form].unitNo;
        break;

      case "complexName":
        if (state.validationsOn[form] && state.validations[form].complexName) {
          fieldErrors[form].complexName = value.length == 0 ? true : false;
          fieldErrors[form].fail = fieldErrors.complexName;
          if (state.fieldValues.addressType == BUSINESS_ADDRESS_TYPE) {
            fieldErrorsMessage[form].complexName =
              state.fieldErrorsMessage.deliveryDetails.officeComplexName;
          } else {
            fieldErrorsMessage[form].complexName =
              state.fieldErrorsMessage.deliveryDetails.complexName;
          }
        } else {
          fieldErrors[form].complexName = false;
        }

        if(state.fieldValues[form].complexName !== "") {
          state.validations.delivery.unitNo = true;
        }
        if(state.fieldValues[form].complexName == "") {
          state.validations.delivery.unitNo = false;
        }
        break;

      case "streetNo":
        if (value.length > 0) {
          fieldErrors[form].streetNo = numRegEx.test(value) ? false : true;
          if (fieldErrors[form].streetNo) {
            fieldErrorsMessage[form].streetNo =
              errorMessages.creditCheckout.deliveryDetails.streetNo.onlyValid;
          }
        } else {
          if (state.validationsOn[form] && state.validations[form].streetNo) {
            fieldErrors[form].streetNo = true;
          } else {
            fieldErrors[form].streetNo = false;
          }

          fieldErrorsMessage[form].streetNo =
            errorMessages.creditCheckout.errors.delivery.deliveryDetails.streetNo;
        }
        fieldErrors[form].fail = fieldErrors[form].streetNo;
        break;

      case "streetName":
        if (state.validationsOn[form] && state.validations[form].streetName) {
          if (value.length > 0) {
            if (!streetNameRegEx.test(value)) {
              fieldErrors[form].streetName = true;
              fieldErrorsMessage[form].streetName =
                errorMessages.creditCheckout.deliveryDetails.streetName.onlyValid;
            } else {
              fieldErrors[form].streetName = false;
            }
          } else {
            fieldErrors[form].streetName = true;
            fieldErrorsMessage[form].streetName =
              errorMessages.creditCheckout.errors.delivery.deliveryDetails.streetName;
          }
          fieldErrors[form].fail = fieldErrors[form].streetName;
        } else {
          fieldErrors[form].streetName = false;
        }
        break;

      case "suburb":
        if (state.validationsOn[form] && state.validations[form].suburb) {
          fieldErrors[form].suburb = value.length == 0 ? true : false;
          fieldErrors[form].fail = fieldErrors[form].suburb;
        } else {
          fieldErrors[form].suburb = false;
        }
        break;

      case "town":
        if (state.validationsOn[form] && state.validations[form].town) {
          fieldErrors[form].town = value.length == 0 ? true : false;
          fieldErrors[form].fail = fieldErrors[form].town;
        } else {
          fieldErrors[form].town = false;
        }
        break;

      case "postalCode":
        if (state.validationsOn[form] && state.validations[form].postalCode) {
          if (value.length > 0) {
            if (!numRegEx.test(value)) {
              fieldErrors[form].postalCode = true;
              fieldErrorsMessage[form].postalCode =
                errorMessages.creditCheckout.deliveryDetails.postalCode.onlyNumber;
            } else if (value.length < 4) {
              fieldErrors[form].postalCode = true;
              fieldErrorsMessage[form].postalCode =
                errorMessages.creditCheckout.deliveryDetails.postalCode.onlyValid;
            } else {
              fieldErrors[form].postalCode = false;
            }
          } else {
            fieldErrors[form].postalCode = true;
            fieldErrorsMessage[form].postalCode =
              errorMessages.creditCheckout.errors.delivery.deliveryDetails.postalCode;
          }
          fieldErrors.fail = fieldErrors[form].postalCode;
        } else {
          fieldErrors[form].postalCode = false;
        }
        break;

      case "province":
        if (state.validationsOn[form] && state.validations[form].province) {
          fieldErrors[form].province = value.length == 0 ? true : false;
          fieldErrors[form].fail = fieldErrors[form].province;
        } else {
          fieldErrors[form].province = false;
        }
        break;
    }

    closeSnackBar();

    setState({
      ...state,
      fieldErrors,
      fieldErrorsMessage,
    });
  };

  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */
  const inlineAnalytics = (message) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_form_event: "error",
      page_errors: message,
      page_form_name: `checkout: credit check: ${customerStatus}: delivery details`,
      page_error_type: "form",
    });
  };

  /**
   * Set the selection analytics(link)
   *
   * @call when dropdown value change(address type, province)
   */
  const selectionAnalytics = (selectionType, value) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: delivery details: ${selectionType}`,
      filter_query: value,
    });
  };

  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */
  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      for (const [key, value] of entries) {
        if ((values[key] == "" && value) || errors[key]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */
  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (const err of errValues) {
      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }

  const addressSearchResultMap = async () => {
    const localityType = finalAddress.address_components;
    if (localityType && localityType.length > 0) {
      await mapAddressSearchData(localityType);

      errorStatus.deliveryDetails = await checkFormError("deliveryDetails");
      setState({
        ...state,
        errorStatus,
      });

      if (errorStatus.deliveryDetails) {
        setSubmitDisabled(true);
      } else {
        checkErrorStatus();
      }
    }
  };

  /**
   * Set the on page submit
   *
   * @call on next button click
   */
  const setAnalyticsOnNextButton = () => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      link_name: `checkout: credit check: ${customerStatus}: delivery details: next`,
    });
  };

  /**
   * Form submit handler
   *
   * @usage call addDeliveryBillingAddress funtion when there is no error
   * @call onSubmit event
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    event.persist();
    closeSnackBar();

    if (selectedReceiveType == "courier") {
      addDeliveryBillingAddress();
    }
  };

  const showFormDetails = async (result) => {
    let newResult = {
      address: mapFormData(result),
      receiveType: selectedReceiveType,
      deliveryType: selectedDeliveryType,
      cellNumber: contactDetailsData?.cellNumber
        ? contactDetailsData.cellNumber
        : "",
    };

    dispatch({
      type: SET_CREDIT_CHECK_DELIVERY_DATA,
      payload: newResult,
    });
  };

  const mapAddressSearchData = async (localityType) => {
    readOnlyValues.deliveryDetails.postalCode = false;

    fieldValues.deliveryDetails.unitNo = "";
    fieldValues.deliveryDetails.complexName = "";
    fieldValues.deliveryDetails.streetNo = "";
    fieldValues.deliveryDetails.streetName = "";
    fieldValues.deliveryDetails.suburb = "";
    fieldValues.deliveryDetails.province = "";
    fieldValues.deliveryDetails.town = "";
    fieldValues.deliveryDetails.postalCode = "";

    fieldErrors.deliveryDetails.unitNo = false;
    fieldErrors.deliveryDetails.complexName = false;
    fieldErrors.deliveryDetails.streetNo = false;
    fieldErrors.deliveryDetails.streetName = false;
    fieldErrors.deliveryDetails.suburb = false;
    fieldErrors.deliveryDetails.province = false;
    fieldErrors.deliveryDetails.town = false;
    fieldErrors.deliveryDetails.postalCode = false;

    for (let i = 0; i < localityType.length; i++) {
      if (localityType[i].administrative_type == UNIT) {
        if (localityType[i].long_name) {
          fieldValues.deliveryDetails.unitNo = localityType[i].long_name;
        }
      }

      if (localityType[i].administrative_type == BUSINESS) {
        fieldValues.deliveryDetails.complexName = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == STREET_NO) {
        fieldValues.deliveryDetails.streetNo = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == ROUTE) {
        fieldValues.deliveryDetails.streetName = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == SUBURB) {
        fieldValues.deliveryDetails.suburb = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == PROVINCE) {
        fieldValues.deliveryDetails.province = getProvinceValue(
          localityType[i].long_name
        );
      }

      if (
        localityType[i].administrative_type == TOWN ||
        localityType[i].administrative_type == CITY
      ) {
        fieldValues.deliveryDetails.town = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == POST_STREET) {
        if (localityType[i].long_name.length > 0) {
          readOnlyValues.deliveryDetails.postalCode = true;
        }
        fieldValues.deliveryDetails.postalCode = localityType[i].long_name;
      }
    }

    setState({
      ...state,
      readOnlyValues,
      fieldValues,
      fieldErrors,
    });
  };

  const mapHomeFieldData = () => {
    let regionValue = homeDetailsData?.province
      ? getRegionValue(homeDetailsData.province)
      : null;

    return {
      cart_id: cartId !== "" ? cartId : null,
      region: regionValue && regionValue.code ? regionValue.code : null,
      country_code: countryCode ? countryCode : null,
      instructions:
        homeDetailsData?.instructions !== ""
          ? homeDetailsData.instructions
          : null,
      street:
        homeDetailsData?.streetName !== ""
          ? seperateStreetString(homeDetailsData.streetName)
          : null,
      postcode:
        homeDetailsData?.postalCode !== "" ? homeDetailsData.postalCode : null,
      city: homeDetailsData?.town !== "" ? homeDetailsData.town : null,
      address_type_name:
        homeDetailsData?.addressType !== "" ? homeDetailsData.addressType : "",
      address_name:
        homeDetailsData?.addressName !== ""
          ? homeDetailsData.addressName
          : "Home",
      company:
        homeDetailsData?.companyName !== ""
          ? homeDetailsData.companyName
          : null,
      unit_number:
        homeDetailsData?.unitNo !== "" ? homeDetailsData.unitNo : null,
      complex_name:
        homeDetailsData?.complexName !== ""
          ? homeDetailsData.complexName
          : null,
      street_number:
        homeDetailsData?.streetNo !== "" ? homeDetailsData.streetNo : null,
      suburb: homeDetailsData?.suburb !== "" ? homeDetailsData.suburb : null,
      firstname: personalDetailsData?.firstName
        ? personalDetailsData.firstName
        : "",
      lastname: personalDetailsData?.surName ? personalDetailsData.surName : "",
      telephone: contactDetailsData?.cellNumber
        ? contactDetailsData.cellNumber
        : "",
      save_in_address_book: true,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: 1,
      is_billing_address: 1,
      same_as_shipping: true,
    };
  };

  const mapFieldData = () => {
    let regionValue = getRegionValue(
      state.fieldValues["deliveryDetails"].province
    );

    return {
      cart_id: cartId !== "" ? cartId : null,
      region: regionValue && regionValue.code ? regionValue.code : null,
      country_code: countryCode ? countryCode : null,
      instructions:
        state.fieldValues["deliveryDetails"].instructions !== ""
          ? state.fieldValues["deliveryDetails"].instructions
          : null,
      street:
        state.fieldValues["deliveryDetails"].streetName !== "" &&
        state.validations["deliveryDetails"].streetName
          ? seperateStreetString(
              state.fieldValues["deliveryDetails"].streetName
            )
          : state.fieldValues["deliveryDetails"].addressLine1 !== "" &&
            state.fieldValues["deliveryDetails"].addressLine2 !== "" &&
            state.validations["deliveryDetails"].addressLine1 &&
            state.validations["deliveryDetails"].addressLine2
          ? createStreetFromAddressLines(
              state.fieldValues["deliveryDetails"].addressLine1,
              state.fieldValues["deliveryDetails"].addressLine2
            )
          : null,
      postcode:
        state.fieldValues["deliveryDetails"].postalCode !== ""
          ? state.fieldValues["deliveryDetails"].postalCode
          : null,
      city:
        state.fieldValues["deliveryDetails"].town !== ""
          ? state.fieldValues["deliveryDetails"].town
          : null,
      address_type_name:
        state.fieldValues["deliveryDetails"].addressType !== ""
          ? state.fieldValues["deliveryDetails"].addressType
          : null,
      address_name:
        state.fieldValues["deliveryDetails"].addressName !== ""
          ? state.fieldValues["deliveryDetails"].addressName
          : null,
      company:
        state.fieldValues["deliveryDetails"].companyName !== ""
          ? state.fieldValues["deliveryDetails"].companyName
          : null,
      unit_number:
        state.fieldValues["deliveryDetails"].unitNo !== ""
          ? state.fieldValues["deliveryDetails"].unitNo
          : null,
      complex_name:
        state.fieldValues["deliveryDetails"].complexName !== ""
          ? state.fieldValues["deliveryDetails"].complexName
          : null,
      street_number:
        state.fieldValues["deliveryDetails"].streetNo !== ""
          ? state.fieldValues["deliveryDetails"].streetNo
          : null,
      suburb:
        state.fieldValues["deliveryDetails"].suburb !== ""
          ? state.fieldValues["deliveryDetails"].suburb
          : null,
      firstname: personalDetailsData?.firstName
        ? personalDetailsData.firstName
        : "",
      lastname: personalDetailsData?.surName ? personalDetailsData.surName : "",
      telephone: contactDetailsData?.cellNumber
        ? contactDetailsData.cellNumber
        : "",
      save_in_address_book: state.fieldValues["deliveryDetails"].futureCheck,
      default_shipping: false,
      default_billing: false,
      is_shipping_address: 1,
      is_billing_address: 1,
      same_as_shipping: true,
    };
  };

  const addDeliveryBillingAddress = async () => {
    if (selectedDeliveryType !== "previous") {
      var inputAddressObj =
        selectedDeliveryType == "home" ? mapHomeFieldData() : mapFieldData();

      if (
        currentJourneyType == journeyType.addLine &&
        inputAddressObj.firstname == ""
      ) {
        inputAddressObj.firstname = profileData?.firstname;
        inputAddressObj.lastname = profileData?.lastname;
      }

      try {
        showSpinner();
        let results = await setNewBillingAddressService(inputAddressObj);

        if (!results.fail) {
          dispatch({
            type: SET_SHIPPING,
            payload: results,
          });
          dispatch({
            type: SET_BILLING,
            payload: results,
          });
          showFormDetails(results.setAddress);
          addShippingMethod();

          Analytics.link({
            ...Analytics.getUtagData([
              "page_name",
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
              "visitor_subscription_type",
            ]),
            page_form_event: "success",
            page_form_name: `checkout: credit check: ${customerStatus}: delivery details`,
          });
        } else {
          hideSpinner();
          if (results && results.errors) {
            technicalFailure(results.errors?.[0]?.message);
          } else {
            technicalFailure();
          }
        }
      } catch {
        hideSpinner();
        technicalFailure();
      }
    } else {
      try {
        showSpinner();
        let results = await setExistingBillAddressService(
          cartId,
          selectedDeliveryAddress,
          true
        );

        if (!results.fail) {
          dispatch({
            type: SET_SHIPPING,
            payload: results,
          });
          dispatch({
            type: SET_BILLING,
            payload: results,
          });
          showFormDetails(results.setAddress);
          addShippingMethod();

          Analytics.link({
            ...Analytics.getUtagData([
              "page_name",
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
              "visitor_subscription_type",
            ]),
            page_form_event: "success",
            page_form_name: `checkout: credit check: ${customerStatus}: delivery details`,
          });
        } else {
          hideSpinner();
          if (results && results.errors) {
            technicalFailure(results.errors?.[0]?.message);
          } else {
            technicalFailure();
          }
        }
      } catch {
        hideSpinner();
        technicalFailure();
      }
    }
  };

  const addShippingMethod = async () => {
    let cart_id = cartId !== "" ? cartId : null;
    let results = await setShippingMethodsOnCartService(
      cart_id,
      carrierCode,
      methodCode
    );

    if (!results.fail) {
      dispatch({ type: SET_SHIPPING_METHOD, payload: results });
    }

    onFormSubmit(true);
    setDisplayEditMode(false);
    doCreditCheckDisable("deliveryDetails", false);
    hideSpinner();
  };

  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */
  const clickOnEditButton = () => {
    setDisplayEditMode(true);
    doCreditCheckDisable("deliveryDetails", true);
  };

  const technicalFailure = (errorMsg) => {
    window.scrollTo(0, 0);
    if (matchWordInString(errorMsg, "authorized")) {
      displaySnackBar(labels.checkout.lbl_session_invalid);
      setReLogin(true);
    } else if (matchWordInString(errorMsg, "cart")) {
      displaySnackBar(labels.checkout.lbl_cart_invalid);
      setReLogin(true);
    } else if (matchWordInString(errorMsg, "server")) {
      if (submitAttempt == 0) {
        displaySnackBar(labels.checkout.lbl_something_went_wrong_try_again);
      } else {
        setAnalyticsOnNextButton();
        fetchErrorDetails(`captureDeliveryDetails_invalid`);
        closeSnackBar();
      }
      setSubmitAttempt(submitAttempt + 1);
    } else {
      displaySnackBar(labels.checkout.lbl_something_went_wrong_try_again);
    }
  };

  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */
  const fetchErrorDetails = async (resultCode) => {
    const pageName = `checkout: credit check: ${customerStatus}: delivery details`;

    try {
      showSpinner();
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [resultCode]
      );

      setPageErr({
        type: "error",
        title: result[0].resultTitle,
        desc:
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
        primaryLabel:
          result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
        primaryUrl:
          result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
        secondaryLabel:
          result[0].secondaryEnabled === "Yes"
            ? result[0].secondaryCTAText
            : null,
        secondaryUrl:
          result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
        handlePrimaryClick: () =>
          handlePrimaryClick(
            generateFormURL(
              result[0].primaryCTAURL,
              result[0].leadType,
              result[0].primaryCTAType
            ),
            result[0].primaryCTAText
          ),
        handleSecondaryClick: () =>
          handleSecondaryClick(
            generateFormURL(
              result[0].secondaryCTAURL,
              result[0].leadType,
              result[0].secondaryCTAType
            ),
            result[0].secondaryCTAText
          ),
        imgUrl: result[0].icon,
        pageName: pageName,
      });
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    } catch {
      setPageErr({
        type: "error",
        title: labels.creditCheckout.deliveryDetails.lbl_invalid_attempt_title,
        desc: labels.creditCheckout.deliveryDetails.lbl_invalid_attempt_desc,
        primaryLabel: "Call me back",
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
        handleSecondaryClick: () => handleSecondaryClick(null, "exit checkout"),
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: pageName,
      });
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    }
  };

  const handlePrimaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url) {
      router.push(`${urlPrefix}${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
        hideSpinner();
      });
    }
  };

  const handleSecondaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url) {
      router.push(`${urlPrefix}${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`${urlPrefix}/cart`).then(() => {
        hideSpinner();
      });
    }
  };

  const displaySnackBar = (message, level = "page_level") => {
    setShowSnackBar({ visible: true, message: message });

    const pageAnalyticsData = {
      page_errors: message,
      page_error_type: "page",
    };

    if (level == "form_level") {
      pageAnalyticsData.page_form_event = "error";
      pageAnalyticsData.page_form_name = `checkout: credit check: ${customerStatus}: delivery details`;
      pageAnalyticsData.page_error_type = "form";
    }

    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      ...pageAnalyticsData,
      link_type: "o",
      link_name: `checkout: credit check: ${customerStatus}: delivery details: next`,
    });
  };

  const closeSnackBar = () => {
    setShowSnackBar({ visible: false, message: "" });
  };

  const showModal = (type, variant, addressData) => {
    setModalType(type);
    setModalVariant(variant);
    setModalValues(addressData);
    setModalShow(true);

    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_form_event: "start",
      page_form_name: `checkout: credit check: ${customerStatus}: delivery details: ${variant} ${type} address`,
    });
  };

  const hideModal = (refresh) => {
    setModalShow(false);

    if (refresh == true) {
      fetchData();
    }
  };

  const addressTileClickHandler = (data) => {
    setSelectedDeliveryAddress(data.id);

    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: delivery details: select delivery address`,
      filter_query: data.address_name,
    });
  };

  /**
   * Radio change event handler
   *
   * @usage Set the id of selected receive type
   * @usage Show the content of selected receive type
   * @call onChange event
   */
  const handleReceiveType = async (val, index) => {
    setSelectedReceiveType(val);

    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: delivery details: delivery type`,
      filter_query:
        receiveTypesOptions[index]?.id == "courier" ? "deliver" : "collect",
    });
  };

  /**
   * Dropdown change event handler
   *
   * @usage Set the id of selected delivery type
   * @usage Show the content of selected delivery type
   * @call onChange event
   */
  const handleDeliveryType = async (event, val, index) => {
    event.persist();
    setSelectedDeliveryType(val);

    if (!analytics) {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "start",
        page_form_name: `checkout: credit check: ${customerStatus}: delivery details`,
      });
      setAnalytics(true);
    }

    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: delivery details: address process`,
      filter_query: deliveryTypeOptions[index]?.label,
    });
  };

  /**
   * Dropdown field reset handler
   *
   * @usage Set the default selected
   */
  const handleDeliveryTypeReset = async () => {
    setSelectedDeliveryType("home");

    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: delivery details: address process`,
      filter_query: deliveryTypeOptions[0]?.label,
    });
  };

  return (
    <>
      <CustomContainer
        className={`${formStyles["container"]}`}
        id="delivery-details"
      >
        <CustomContainer className={formStyles["form-heading"]}>
          {displayEditMode ? (
            <Image
              img_path={`${imagePrefix}/assets/images/icon-delivery.svg`}
              img_alt="section"
              className={formStyles["section-icon"]}
            />
          ) : (
            <Image
              img_path={`${imagePrefix}/assets/images/success-circle_small.svg`}
              img_alt="succes"
              className={formStyles["section-success-icon"]}
            />
          )}
          Delivery details
          {displayEditMode ? (
            <CustomContainer className={formStyles["section-numbers"]}>
              {currentJourneyType != journeyType.addLine
                ? "Section 6 of 7"
                : "Section 4 of 5"}
            </CustomContainer>
          ) : (
            <CustomContainer className={formStyles["section-numbers"]}>
              <a onClick={() => clickOnEditButton(true)}>
                <Image
                  img_path={`${imagePrefix}/assets/images/blog.svg`}
                  img_alt="edit"
                />
                <span>Edit details</span>
              </a>
            </CustomContainer>
          )}
        </CustomContainer>
        <hr></hr>
        {!displayEditMode ? (
          <DeliveryDetailsInfo
            data={deliveryDetailsData}
            stateTypesOptions={stateTypesOptions}
          />
        ) : (
          <CustomContainer className={formStyles["pt-2"]}>
            {/* <ReceiveType
              heading={
                labels.creditCheckout.deliveryDetails.lbl_receive_type_title
              }
              selectedType={selectedReceiveType}
              receiveTypes={receiveTypesOptions}
              handleReceiveType={handleReceiveType}
              id="checkout-credit-check-receive-type-select"
            /> */}
            {selectedReceiveType == "courier" && (
              <CustomContainer className={styles["courier"]}>
                <CustomContainer className={styles["delivery-selection"]}>
                  <PageHeading
                    text={
                      labels.creditCheckout.deliveryDetails
                        .lbl_delivery_type_title
                    }
                    level={3}
                    className={`${styles["delivery-selection__heading"]} ${styles["mt-m"]}`}
                  />
                  <div className={`${styles["select-row"]} ${styles["mt-m"]}`}>
                    <div className={`${styles["select-group"]}`}>
                      <DropDown
                        label="Delivery type"
                        name="deliveyType"
                        data={deliveryTypeOptions}
                        handleSelect={handleDeliveryType}
                        handleReset={handleDeliveryTypeReset}
                        resetRequired={true}
                        selectedId={selectedDeliveryType}
                        customId="checkout-credit-check-delivey-type-select"
                      />
                    </div>
                  </div>
                </CustomContainer>
                {selectedDeliveryType == "home" && (
                  <CustomContainer
                    className={`${styles["home-address"]} ${styles["mtb-m"]}`}
                  >
                    {displayHomeAddress()}
                  </CustomContainer>
                )}
                {selectedDeliveryType == "previous" && (
                  <CustomContainer
                    className={`${styles["tiles-section"]} ${styles["mtb-m"]}`}
                  >
                    {deliveryAddresslists.map((item, index) => (
                      <AddressTile
                        type="delivery"
                        variant="edit"
                        data={item}
                        key={index}
                        handleOnEdit={showModal}
                        handleOnClick={addressTileClickHandler}
                        selectedAddress={selectedDeliveryAddress}
                        deleteOption={false}
                        id={`checkout-credit-check-delivery-address-tile-${index}`}
                      />
                    ))}
                  </CustomContainer>
                )}
                {selectedDeliveryType == "another" && (
                  <CustomContainer
                    className={`${styles["another-address"]} ${styles["mt-m"]}`}
                  >
                    <PageHeading
                      text={
                        labels.creditCheckout.deliveryDetails
                          .lbl_another_address_title
                      }
                      level={3}
                      className={styles["another-address__heading"]}
                    />

                    <CustomContainer
                      className={`${"d-none " + formStyles["search-wrapper"]} ${styles["mt-m"]}`}
                    >
                      <ContentSearchBox
                        className={formStyles["search-wrapper__input"]}
                        placeholderText="Search for your address"
                        icon="blue"
                        variant="address-search"
                        setFinalAddress={setFinalAddress}
                        pageName={`checkout: credit check: ${customerStatus}`}
                        analyticFormName="delivery details"
                      ></ContentSearchBox>
                    </CustomContainer>

                    <Form
                      noValidate
                      id="checkout-credit-check-delivery-address-form"
                    >
                      <DeliveryDetailsForm
                        formName={"deliveryDetails"}
                        validations={state.validations["deliveryDetails"]}
                        fieldValues={state.fieldValues["deliveryDetails"]}
                        fieldErrors={state.fieldErrors["deliveryDetails"]}
                        fieldErrorsMessage={
                          state.fieldErrorsMessage["deliveryDetails"]
                        }
                        readOnlyValues={state.readOnlyValues["deliveryDetails"]}
                        addressTypesOptions={addressTypesOptions}
                        stateTypesOptions={stateTypesOptions}
                        onChangeHandler={handleChange}
                        onBlurHandler={handleBlur}
                      ></DeliveryDetailsForm>
                    </Form>
                  </CustomContainer>
                )}

                <CustomContainer className={styles["contact"]}>
                  <PageHeading
                    text={
                      labels.creditCheckout.deliveryDetails.lbl_courier_title
                    }
                    level={3}
                    className={`${styles["contact__heading"]} ${styles["mt-m"]}`}
                  />
                  <div className={styles["contact__value"]}>
                    {contactDetailsData?.cellNumber}
                  </div>
                </CustomContainer>
              </CustomContainer>
            )}
            {selectedReceiveType == "store" && (
              <CustomContainer className={styles["store"]}>
                <DeliveryTitle
                  title={labels.creditCheckout.deliveryDetails.lbl_store_title}
                  contents={titleContents}
                  className={styles["mt-m"]}
                  id={`checkout-credit-check-store-standard-delivery`}
                  iconType="dot"
                />
                <PageHeading
                  text={
                    labels.creditCheckout.deliveryDetails.lbl_collect_type_title
                  }
                  level={3}
                  className={`${styles["seacrh-heading"]} ${styles["mt-m"]}`}
                />
                <CustomContainer
                  className={`${"d-none " + formStyles["search-wrapper"]} ${styles["mtb-m"]}`}
                >
                  <ContentSearchBox
                    className={formStyles["search-wrapper__input"]}
                    placeholderText={
                      labels.creditCheckout.deliveryDetails
                        .lbl_store_search_title
                    }
                    icon="blue"
                    variant="address-search"
                    setFinalAddress={setFinalAddress}
                    pageName={`checkout: credit check: ${customerStatus}`}
                    analyticFormName="delivery details"
                  ></ContentSearchBox>
                </CustomContainer>
              </CustomContainer>
            )}

            <CustomContainer className={formStyles["button-wrapper"]}>
              <CTAButton
                type="button"
                variant="solid grey"
                disabled={submitDisabled}
                className={formStyles["button"]}
                id="checkout-credit-check-delivery-address-submit"
                handleClick={(event) => handleSubmit(event)}
              >
                Next
              </CTAButton>
            </CustomContainer>
          </CustomContainer>
        )}
      </CustomContainer>

      <CheckoutFormsModal
        show={modalShow}
        hide={hideModal}
        formType={modalType}
        variant={modalVariant}
        values={modalValues}
        addressTypes={addressTypesOptions}
        statesTypes={stateTypesOptions}
        countryCode={countryCode}
        countryName={countryName}
        cartId={cartId}
        step="creditCheck"
        deleteOption={false}
        pageName={`checkout: credit check: ${customerStatus}: delivery details`}
        isGuestUser={userLoggedIn ? false : true}
      ></CheckoutFormsModal>
    </>
  );
};

DeliveryDetails.propTypes = {
  customerStatus: PropTypes.string,
  onFormSubmit: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    personalDetailsData: state.creditCheckDetails.personalDetails,
    homeDetailsData: state.creditCheckDetails.homeDetails,
    contactDetailsData: state.creditCheckDetails.contactDetails,
    deliveryDetailsData: state.creditCheckDetails.deliveryDetails,
    profileLoading: state.navDetails.isProfileLoading,
  };
};

const mapDispatchToProps = {
  setReLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDetails);
